import { FocusEvent, ChangeEvent, KeyboardEvent, useCallback } from "react"
import Input from "./input"
import { REGEX_HEX_COLOR } from "../../constants"

type Props = {
  name: string
  label: string
  value?: string
  required?: boolean
  className?: string
  inputFieldClassName?: string
  innerWrapperClassName?: string
  labelClassName?: string
  helpText?: string
  showLabel?: boolean
  onChangeWhell?: (e: ChangeEvent<HTMLInputElement>) => void
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void
  onBlur?: (e: FocusEvent<HTMLInputElement>) => void
}

const InputColorPicker = ({
  name,
  label,
  value = "",
  required,
  className,
  inputFieldClassName,
  innerWrapperClassName,
  labelClassName,
  helpText,
  showLabel = true,
  onChange,
  onChangeWhell,
  onBlur
}: Props) => {
  const onChangeColor = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => onChange?.(e),
    [onChange]
  )

  const onChangeWhellColor = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => onChangeWhell?.(e),
    [onChangeWhell]
  )

  const onChangeColorManual = useCallback(
    (e: KeyboardEvent<HTMLInputElement>) => {
      if (e.key === "Enter") {
        const newValue = e.currentTarget.value

        if (REGEX_HEX_COLOR.test(newValue)) {
          e.currentTarget.blur()
        }
      }
    },
    []
  )

  return (
    <>
      <Input
        className={className}
        inputFieldClassName={inputFieldClassName}
        innerWrapperClassName={innerWrapperClassName}
        labelClassName={labelClassName}
        helpText={helpText}
        showLabel={showLabel}
        inputProps={{
          required: required,
          value: value,
          onKeyPress: onChangeColorManual,
          onChange: onChangeColor,
          onBlur: onBlur,
          ...(value ? { pattern: REGEX_HEX_COLOR } : {})
        }}
        label={label}
        name={name}
        placeholder="Ex. #000000"
        beforeIcon={
          value ? (
            <div
              className="h-6 w-6"
              style={{
                backgroundColor: value
              }}
            />
          ) : undefined
        }
        afterIcon={
          <label className="pallet-icon cursor-pointer">
            <input
              name={name}
              className="sr-only"
              type="color"
              onChange={onChangeWhellColor}
              value={value}
            />
          </label>
        }
      />
    </>
  )
}

export default InputColorPicker
